import { padNumberToLength } from '../utils/pad-number-to-length';
/**
 * Returns a numerical representation of the day of the month: 1, 2, ..., 31
 * @hidden
 */
export const getDayOfMonthNumeric = ({ offsetUtcDate }) => {
    return offsetUtcDate.getUTCDate();
};
/**
 * Returns an ordinal string representation of the day of the month: 1st, 2nd, ..., 31st
 * @hidden
 */
export const getDayOfMonthOrdinal = (params) => {
    const dayOfMonth = getDayOfMonthNumeric(params);
    return params.ordinalStringFormatter(dayOfMonth);
};
/**
 * Returns a two-digit string representation of the day of the month: 01, 02, ..., 31
 * @hidden
 */
export const getDayOfMonthTwoDigit = (params) => {
    const dayOfMonth = getDayOfMonthNumeric(params);
    return padNumberToLength(dayOfMonth, 2);
};
//# sourceMappingURL=day-of-month.js.map